import React, { useState, useEffect } from 'react';
import styles from './MalliAkka.module.css';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import malliAkkaImage1 from '../../images/Malli-Akka-1.jpg';
import malliAkkaImage2 from '../../images/Malli-Akka-2.jpg';
import malliAkkaImage3 from '../../images/Malli-Akka-3.jpg';
import malliAkkaImage4 from '../../images/Malli-Akka-4.jpg';
import malliAkkaImage5 from '../../images/Malli-Akka-5.jpg';
import malliAkkaImage6 from '../../images/Malli-Akka-6.jpg';

const MalliAkkaPortfolio = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [isImageHovered, setIsImageHovered] = useState(false);
  const [isImage1Clicked, setIsImage1Clicked] = useState(false);
  const [isImage3Hovered, setIsImage3Hovered] = useState(false);
  const [isImage3Clicked, setIsImage3Clicked] = useState(false);
  const [isImage5Hovered, setIsImage5Hovered] = useState(false);
  const [isImage5Clicked, setIsImage5Clicked] = useState(false);
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [showCursor, setShowCursor] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');
  const [scrolled, setScrolled] = useState(false);
  const [showHint, setShowHint] = useState(true);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setShowHint(false), 4000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setCursorPos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />
      


      {/* Custom Cursor Follower */}
      {showCursor && (
        <div style={{
          position: 'fixed',
          left: cursorPos.x,
          top: cursorPos.y,
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
          zIndex: 9999,
          transition: 'opacity 0.2s ease'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #f39c12, #e67e22)',
            color: 'white',
            padding: '0.5rem 1rem',
            borderRadius: '1rem',
            fontSize: '0.9rem',
            fontWeight: '600',
            boxShadow: '0 8px 20px rgba(243, 156, 18, 0.4)',
            whiteSpace: 'nowrap',
            animation: 'cursorBounce 0.6s ease-in-out infinite'
          }}>
            ✨ Click to lock!
          </div>
        </div>
      )}

      <div className={styles.container}>
      {/* Animated Background Elements */}
      <div className={styles.bgAnimation}>
        <div className={`${styles.bgOrb} ${styles.bgOrb1}`}></div>
        <div className={`${styles.bgOrb} ${styles.bgOrb2}`}></div>
        <div className={`${styles.bgOrb} ${styles.bgOrb3}`}></div>
      </div>

      {/* Header */}
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.badge}>CHARACTER DESIGN PORTFOLIO</div>
          <h1 className={styles.mainTitle}>Malli Akka</h1>
          <p className={styles.subtitle}>The Spirited South Indian Matriarch</p>
          <div className={styles.tags}>
            <span className={styles.tag}>🌺 Traditional</span>
            <span className={styles.tag}>✨ Expressive</span>
            <span className={styles.tag}>🎭 Dynamic</span>
          </div>
        </div>
      </header>

      <div className={styles.mainContent}>
        
        {/* Character Overview */}
        <section className={styles.section}>
          <div className={`${styles.sectionGlow} ${styles.glowOrange}`}></div>
          <div className={styles.sectionCard}>
            <h2 className={styles.sectionTitle}>
              <span className={styles.titleIcon}>👤</span> Character Overview
            </h2>
            <div className={styles.singleInfoCard}>
              <div className={styles.infoRow}>
                <span className={styles.infoIcon}>👤</span>
                <span className={styles.infoLabel}>Name</span>
                <span className={styles.infoValue}>Malli Akka</span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.infoIcon}>🎂</span>
                <span className={styles.infoLabel}>Age Range</span>
                <span className={styles.infoValue}>Mid-40s</span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.infoIcon}>🌍</span>
                <span className={styles.infoLabel}>Ethnicity</span>
                <span className={styles.infoValue}>South Indian</span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.infoIcon}>💼</span>
                <span className={styles.infoLabel}>Occupation</span>
                <span className={styles.infoValue}>Homemaker, neighborhood gossip queen, scooter-riding multitasker</span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.infoIcon}>🏘️</span>
                <span className={styles.infoLabel}>Setting</span>
                <span className={styles.infoValue}>A vibrant urban neighborhood in Kerala</span>
              </div>
            </div>
          </div>
        </section>

        {/* Visual Identity */}
        <section className={styles.section}>
          <div className={`${styles.sectionGlow} ${styles.glowPurple}`}></div>
          <div className={styles.sectionCard}>
            <h2 className={styles.sectionTitle}>
              <span className={styles.titleIcon}>✨</span> Visual Identity
            </h2>
            <div className={styles.visualGrid}>
              <div className={`${styles.visualCard} ${styles.visualCard1}`}>
                <h3 className={styles.visualTitle}>👗 Outfit</h3>
                <p className={styles.visualDesc}>Traditional cream-colored sari with gold border, maroon blouse</p>
              </div>
              <div className={`${styles.visualCard} ${styles.visualCard2}`}>
                <h3 className={styles.visualTitle}>💍 Accessories</h3>
                <p className={styles.visualDesc}>Gold jewelry (necklace, bangles, earrings), bindi, anklets</p>
              </div>
              <div className={`${styles.visualCard} ${styles.visualCard3}`}>
                <h3 className={styles.visualTitle}>💇‍♀️ Hair</h3>
                <p className={styles.visualDesc}>Long black waves with white streaks, tied or flowing</p>
              </div>
              <div className={`${styles.visualCard} ${styles.visualCard4}`}>
                <h3 className={styles.visualTitle}>🎭 Expression</h3>
                <p className={styles.visualDesc}>Highly expressive—joy, suspicion, anger, mischief to serenity</p>
              </div>
            </div>
          </div>
        </section>

        {/* Character Turnaround */}
        <section className={styles.section}>
          <div className={`${styles.sectionGlow} ${styles.glowBlue}`}></div>
          <div className={styles.sectionCard}>
            <h2 className={styles.sectionTitle}>
              <span className={styles.titleIcon}>🔄</span> Character Turnaround
            </h2>
            <p className={styles.sectionDesc}>Front, side, and back views establishing silhouette, posture, and costume details.</p>
            <div style={{position: 'relative', cursor: 'pointer'}} onMouseEnter={() => {setIsImageHovered(true); setShowCursor(true);}} onMouseLeave={() => {setIsImageHovered(false); setShowCursor(false);}} onClick={() => setIsImage1Clicked(!isImage1Clicked)}>
              <img 
                src={malliAkkaImage1} 
                alt="Character Turnaround" 
                className={styles.malliakkaImg}
                style={{width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isImageHovered ? 'scale(1.02)' : 'scale(1)', opacity: (isImageHovered || isImage1Clicked) ? 0 : 1}} 
              />
              <img 
                src={malliAkkaImage2} 
                alt="Character Turnaround" 
                className={styles.malliakkaImg}
                style={{position: 'absolute', top: 0, left: 0, width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isImageHovered ? 'scale(1.02)' : 'scale(1)', opacity: (isImageHovered || isImage1Clicked) ? 1 : 0}} 
              />
            </div>
          </div>
        </section>

        {/* Expression Sheet */}
        <section className={styles.section}>
          <div className={`${styles.sectionGlow} ${styles.glowPink}`}></div>
          <div className={styles.sectionCard}>
            <h2 className={styles.sectionTitle}>
              <span className={styles.titleIcon}>🎭</span> Expression Sheet
            </h2>
            <p className={styles.sectionDesc}>10 distinct facial expressions showcasing emotional range and storytelling potential.</p>
            <div style={{position: 'relative', cursor: 'pointer'}} onMouseEnter={() => {setIsImage5Hovered(true); setShowCursor(true);}} onMouseLeave={() => {setIsImage5Hovered(false); setShowCursor(false);}} onClick={() => setIsImage5Clicked(!isImage5Clicked)}>
              <img 
                src={malliAkkaImage5} 
                alt="Expression Sheet" 
                className={styles.malliakkaImg}
                style={{width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isImage5Hovered ? 'scale(1.02)' : 'scale(1)', opacity: (isImage5Hovered || isImage5Clicked) ? 0 : 1}} 
              />
              <img 
                src={malliAkkaImage6} 
                alt="Expression Sheet" 
                className={styles.malliakkaImg}
                style={{position: 'absolute', top: 0, left: 0, width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isImage5Hovered ? 'scale(1.02)' : 'scale(1)', opacity: (isImage5Hovered || isImage5Clicked) ? 1 : 0}} 
              />
            </div>
          </div>
        </section>

        {/* Lifestyle & Action Poses */}
        <section className={styles.section}>
          <div className={`${styles.sectionGlow} ${styles.glowOrange}`}></div>
          <div className={styles.sectionCard}>
            <h2 className={styles.sectionTitle}>
              <span className={styles.titleIcon}>🧵</span> Lifestyle & Action Poses
            </h2>
            <p className={styles.sectionDesc}>Dynamic everyday scenarios illustrating personality through action and interaction.</p>
            
            <div style={{position: 'relative', cursor: 'pointer'}} onMouseEnter={() => {setIsImage3Hovered(true); setShowCursor(true);}} onMouseLeave={() => {setIsImage3Hovered(false); setShowCursor(false);}} onClick={() => setIsImage3Clicked(!isImage3Clicked)}>
              <img 
                src={malliAkkaImage3} 
                alt="Action Poses" 
                className={styles.malliakkaImg}
                style={{width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isImage3Hovered ? 'scale(1.02)' : 'scale(1)', opacity: (isImage3Hovered || isImage3Clicked) ? 0 : 1}} 
              />
              <img 
                src={malliAkkaImage4} 
                alt="Action Poses" 
                className={styles.malliakkaImg}
                style={{position: 'absolute', top: 0, left: 0, width: '100%', borderRadius: '1rem', boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)', transition: 'all 1.5s ease', transform: isImage3Hovered ? 'scale(1.02)' : 'scale(1)', opacity: (isImage3Hovered || isImage3Clicked) ? 1 : 0}} 
              />
            </div>
            </div>
        </section>

         <section className={styles.section}>
          <p style={{fontSize: '2.2rem', lineHeight: 1.1, fontWeight: 200, color:'#636e72'}}>Key action poses include gossiping with neighbors featuring animated hand gestures and sly smiles, a scooter ride with parrot showing wind-blown sari and joyful expression, snacking on samosas with crumbs flying and exaggerated delight, cooking over traditional stove with sweat, steam, and intensity, scolding a mischievous cat in dramatic pose and expressive anger, and a flower basket scene for storytelling through gesture and props.</p>
        </section>

        {/* Design Notes */}
        <section className={styles.section}>
          <div className={`${styles.sectionGlow} ${styles.glowRed}`}></div>
          <div className={`${styles.sectionCard} ${styles.notesCard}`}>
            <h2 className={`${styles.sectionTitle} ${styles.notesTitleWhite}`}>
              <span className={styles.titleIcon}>📝</span> Design Notes
            </h2>
            <div className={styles.notesGrid}>
              <div className={styles.noteItem}>
                <h3 className={styles.noteTitle}>🏛️ Cultural Anchoring</h3>
                <p className={styles.noteDesc}>Every detail—from attire to props—reinforces her South Indian identity</p>
              </div>
              <div className={styles.noteItem}>
                <h3 className={styles.noteTitle}>📖 Narrative Function</h3>
                <p className={styles.noteDesc}>Designed to be both comedic and heartfelt, ideal for animated shorts, educational content, or social satire</p>
              </div>
              <div className={styles.noteItem}>
                <h3 className={styles.noteTitle}>🎬 Animation Potential</h3>
                <p className={styles.noteDesc}>Exaggerated expressions and dynamic poses make her ideal for 2D animation and motion comics</p>
              </div>
            </div>
          </div>
        </section>

        

      </div>

      <div className={styles.footerOverride}>
        <Footer mode={mode} />
      </div>
      </div>
    </>
  );
};

export default MalliAkkaPortfolio;